import { apiSlice } from './apiSlice';

export const clientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllClients: builder.query({
      query: () => ({
        url: `/api/clients`,
        method: 'GET',
      }),
      transformResponse: (response) => response.clients, // directly return clients array
      providesTags: ['Clients'],
    }),

    getClientById: builder.query({
      query: ({ clientId, isClientAdmin = false }) => {
        const params = new URLSearchParams();
        if (isClientAdmin) {
          params.append('is_client_admin', String(isClientAdmin));
        }
        return {
          url: `/api/clients/${clientId}?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => response.client, // directly return the client object
      providesTags: (result, error, { clientId }) => [{ type: 'Client', id: clientId }],
    }),

    createClient: builder.mutation({
      query: (newClient) => ({
        url: `/api/clients`,
        method: 'POST',
        body: newClient,
      }),
      invalidatesTags: ['Clients'],
    }),
    updateClient: builder.mutation({
      query: ({ clientId, ...updatedClient }) => ({
        url: `/api/clients/${clientId}`,
        method: 'PUT',
        body: updatedClient,
      }),
      invalidatesTags: (result, error, { clientId }) => [
        { type: 'Client', id: clientId }, // Invalidate the specific client
        'Clients',
        'VersionLog', // Invalidate the list of clients
      ],
    }),
    getClientsByCustomerId: builder.query({
      query: (customerId) => ({
        url: `/api/customers/${customerId}/clients`,
        method: 'GET',
      }),
      transformResponse: (response) => response.clients,
      providesTags: ['Clients'],
    }),
  }),
});

export const {
  useGetAllClientsQuery,
  useGetClientByIdQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useGetClientsByCustomerIdQuery,
} = clientApiSlice;
